import { render, staticRenderFns } from "./OnboardingForm.vue?vue&type=template&id=4e854473&scoped=true"
import script from "./OnboardingForm.vue?vue&type=script&lang=js"
export * from "./OnboardingForm.vue?vue&type=script&lang=js"
import style0 from "./OnboardingForm.vue?vue&type=style&index=0&id=4e854473&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e854473",
  null
  
)

export default component.exports